import { useState, useEffect, useContext } from 'react';
import { LanguageContext } from '../../utils/lang_provider';
import Pagination from '../../templates/pagination';
import { fetchImage } from '../../utils/fetch'
import { Divider, Flex } from 'antd';
import DisplayElements from '../../templates/display_element'

function News({items}) {
  const [currentPage, setCurrentPage] = useState(0);
  const [articleImages, setArticleImages] = useState([]);
  const [articleImagesLoaded, setArticleImagesLoaded] = useState(false);
  const { language } = useContext(LanguageContext);
  const articlesPerPage = 6;
  const [totalPages, setTotalPages] = useState(0);


  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    setTotalPages(Math.ceil((items.length || 0) / articlesPerPage));
  }, [articlesPerPage, items]);

  useEffect(() => {
        async function loadArticleImages() {
            const newArticleImages = {};
            setArticleImagesLoaded(false);
            try {
                for (const article of items) {
                    if (article.id != null) {
                        const imageResponse = await fetchImage(`front/image/article/${article.id}/thumbnail.png`, language, {size: "thumbnail"});
                        if (imageResponse.ok) {
                            const imageBlob = await imageResponse.blob();
                            newArticleImages[article.id] = URL.createObjectURL(imageBlob);
                        } else {
                            newArticleImages[article.id] = null;
                        }
                    }
                }
                setArticleImages(newArticleImages);
                setArticleImagesLoaded(true);
            } catch (error) {
                console.log("Failed to load images: " + error);
            }
        }
        loadArticleImages();
    }, [items, language]);

  return (
    <Flex vertical justify='center' align='center'>
      <h1>{language === 'sk' ? "Nedávne príspevky" : "Recent posts"}</h1>
      <Divider></Divider>
      <DisplayElements 
        items={items.slice(currentPage * articlesPerPage, currentPage * articlesPerPage + articlesPerPage)}
        images={articleImages}
        imagesLoaded={articleImagesLoaded}
        language={language}
      />
      <Divider></Divider>
      <Pagination totalPages={totalPages} handlePageChange={handlePageChange} currentPage={currentPage}/>
      <Divider></Divider>
    </Flex>
  );
}

export default News;
